<template>
    <el-dialog title="微信扫码支付" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-pay">
        <img src="../assets/images/close.png" alt="关闭" @click="cancelVipHandler()" class="close-img">
        <div alt="二维码" class="code-img qrcode" id="qrcode" ref="qrcode"></div>
        <!-- <img alt="二维码" :src="qrcode"> -->
        <!-- <div v-html="qrcode"></div> -->
        <div class="pay-title">{{wechatPay.title[0] + wechatPay.title[1] + wechatPay.title[2]}}</div>
        <div class="pay-fee"><span>¥</span>{{wechatPay.fee}}</div>
        <button @click="goToPayResult">我已支付</button>
    </el-dialog>
</template>

<script>
import QRCode from 'qrcodejs2'
import { mapState } from "vuex"

export default {
    created () {
        let that = this
        this.$nextTick(() => {
            let qr = new QRCode(that.$refs.qrcode,{
                width: 290,
                height: 290,
                text: that.wechatPay.qr_code
            })
        })
    },
    computed: {
        ...mapState({
            wechatPay: state => state.user.qr_code
        }),
    },
    methods: {
        cancelVipHandler() {
            this.$store.commit('user/SHOWWECHAT', false);
        },
        goToPayResult() {
            this.$store.commit('user/QRCODE',this.wechatPay)
            this.$store.commit('user/SHOWWECHAT', false);
            let path = this.$route.path
            if(path.indexOf('buy') != -1) {
                this.$router.push({
                    path: '/payResult',
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.dialog-pay {
    text-align: center;
    .close-img {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 28px;
        right: 40px;
    }
    .code-img {
        width: 290px;
        height: 290px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 50px;
    }
    .pay-title {
        color: #2c2e33;
        font-size: 20px;
        font-weight: 400;
        margin-top: 40px;
        margin-bottom: 20px;
    }
    .pay-fee {
        color: #ee4444;
        font-size: 32px;
        span {
            font-size: 20px;
        }
    }
    button {
        width: 152px;
        height: 52px;
        border: none;
        background: linear-gradient(90deg,#ffa94a, #ff913c);
        border-radius: 8px;
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
        margin-top: 24px;
    }
}
</style>